import React from 'react';
import { string, bool, func } from 'prop-types';
import cn from 'classnames';
import { IonIcon } from '@ionic/react';
import { trashOutline } from 'ionicons/icons';

import CustomButton from '~components/CustomButton';
import { ReactComponent as CheckIcon } from '~assets/circle_check_rounded.svg';

import styles from './styles.module.scss';
import { ENABLED_TO_SHOW_PAYMENT_NAMES } from './constants';

function PaymentButton({
  id,
  name,
  selected,
  onClick,
  ariaLabel,
  className,
  iconClassName,
  disabled,
  hasTooltipMessage,
  editingCards,
  onDeleteCard,
  isACreditCard
}) {
  const handleDelete = e => {
    e.stopPropagation();
    onDeleteCard();
  };
  return (
    <div className={styles.container}>
      {selected && <CheckIcon className={cn(styles.checkIcon, { [styles.credit]: isACreditCard })} />}
      <CustomButton
        id={id}
        type="button"
        btnClassType="outlined"
        fullWidth
        textCapitalize
        onClick={onClick}
        selected={selected}
        disabled={disabled}
        className={cn(styles.cardPaymentContainer, className)}
        ariaLabel={ariaLabel}>
        <div className="column center full-width">
          <img src={iconClassName} alt={ariaLabel} className={cn(styles.icon, styles[id])} height={32} />
          <span
            className={cn(styles.cardTextName, {
              [styles.selected]: selected
            })}>
            {(ENABLED_TO_SHOW_PAYMENT_NAMES.includes(id) || isACreditCard) && name}
            {hasTooltipMessage && <i className={`icon-info ${styles.iconInfo}`} />}
          </span>
        </div>
        {editingCards && (
          <button onClick={handleDelete} type="button" className={styles.deleteTrashCan}>
            <IonIcon className={styles.iconTrash} icon={trashOutline} />
          </button>
        )}
      </CustomButton>
    </div>
  );
}

PaymentButton.propTypes = {
  ariaLabel: string,
  className: string,
  disabled: bool,
  editingCards: bool,
  hasTooltipMessage: bool,
  iconClassName: string,
  id: string,
  isACreditCard: bool,
  name: string,
  selected: bool,
  onClick: func,
  onDeleteCard: func
};

PaymentButton.defaultProps = {
  disabled: false,
  hasTooltipMessage: false,
  iconClassName: '',
  isACreditCard: false
};

export default PaymentButton;
